import { Component } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { GeneralComponent } from '../../General/g.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';

@Component({
  selector: 'app-t-multiple-choice',
  templateUrl: './t-multiple-choice.component.html',
  styleUrls: ['./t-multiple-choice.component.css']
})
export class TMultipleChoiceComponent extends GeneralTeacherComponent {

  answers: string[] =["",""];
  answerType: string = "checkbox";
  private solutionCode: string;
  checkedRadio: number;
  checkedBox: boolean[] = [false, false];
  answerLength:number = 2;

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService) {
    super(topicService, activatedRoute);
    this.type = "multipleChoice";
    this.title = this.get("multipleChoice");
  }

  generateDefinition() {
    let definition: any = {};
    definition.title = this.title;
    definition.description = this.description;
    definition.type = this.type;
    definition.level = 2;
    definition.image = "./assets/images/openQuestion_white.png";
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.key = "dataRepresentation%positionRepresentation%";
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.answers = this.answers;
    definition.typespecifics.solutionCode = this.computeSolutionCode();
    definition.key = definition.key.concat(this.description, "%", definition.typespecifics.solutionCode);
    definition.typespecifics.type = this.answerType;
    return definition;
  }

  setInformationWithConfiguration(){
    super.setInformationWithConfiguration();
    this.configuration = this.topicService.getExerciseById(this.examId, this.id);
    this.title = this.configuration.title;
    this.description = this.configuration.description;
    this.answers = this.configuration.typespecifics.answers;
    this.answerLength = this.answers.length;
    this.answerType = this.configuration.typespecifics.type;
    this.solutionCode = this.configuration.typespecifics.solutionCode;
    let countCorrectAnswers:number = 0;
    let solution:Set<number> = new Set();
    let primes:number[] = [7, 11, 13, 17, 19];
    for(let prime of primes){
      if(+this.solutionCode.charAt(prime)%2 == 0 ){
        countCorrectAnswers++;
      } else{
        break;
      }
    }
    // get IDs of correct solutions
    for(let p of this.createArray(countCorrectAnswers)){
      solution.add(+this.solutionCode.charAt((p+1)*(countCorrectAnswers)));
    }
    if(this.answerType == "checkbox"){
      this.checkedBox = new Array(this.answerLength).fill(false);
      for(let s of Array.from(solution)){
        this.checkedBox[s] = true;
      }
    } else {
      this.checkedRadio = +this.solutionCode[1];
    }
  }

  reset(){
    super.reset();
    this.answers = [];
    this.answerType = "checkbox";
    this.title = this.get("multipleChoice");;
    this.description="";
    this.id=undefined;
    this.answerLength = 2;
    this.checkedBox = [false, false];
    this.checkedRadio = undefined;
  }

  /** computes the solution code for multiple choice questions */
  computeSolutionCode(): string {
    let solution: string = "";
    let primes:number[] = [7, 11, 13, 17, 19];
    let correntAnswerCount = this.checkedBox.filter((value)=>value).length;
    if(this.answerType=="radio"){
      correntAnswerCount = 1;
    }
    let ids = this.checkedBox.map((value, index)=>[value,index]).filter((value)=>(value[0])).map((value)=>value[1]);
    if(this.answerType=="radio"){
      ids=[this.checkedRadio];
    }
    for(let i = 0; i < 30; i++){
      let next = Math.floor(Math.random() * 10)
      // if in the series of ids, set next as id
      if(i%correntAnswerCount==0){
        if(i <= correntAnswerCount * (correntAnswerCount) && i >= correntAnswerCount){
          next = <number> ids[i/correntAnswerCount-1];
        }
      }
      // if one of the primes, set accordingly
      let pindex = primes.indexOf(i);
      if(pindex != -1){
        if(pindex < correntAnswerCount){
          if(next%2!=0){
            next--;
          }
        } else {
          if(next%2==0){
            next++;
          }
        }
      }
      solution = solution.concat(next.toString());
    }
    return solution;
  }

  /** add an additional answer */
  addAnswer(){
    if(this.answerLength == 5){
      return;
    }
    this.answers.push("");
    this.checkedBox.push(false);
    this.answerLength++;
  }

  /**
   * deletes the given answer
   * @param id - id of answer to delete
   */
  deleteAnswer(id:number){
    if(this.answerLength == 2){
      return;
    }
    this.answers.splice(id, 1);
    this.checkedBox.splice(id, 1);
    if(this.checkedRadio == id){
      this.checkedRadio == undefined;
    }
    this.answerLength--;
  }

}
